const AVAILABLE_CHECK_STORAGE_KEY = 'rpr_storage_available_check';
const STORAGE_EXPIRY_KEY = 'rpr_storage_expiration';

export const ls = {
  get(key: string): string | null {
    if (!this.isAvailable) return null;

    if (this._isExpired) this.removeReproEntries();
    return localStorage.getItem(key);
  },
  set(key: string, val: string, { expires = 2 * 365 /* days */ } = {}): void {
    if (!this.isAvailable) return;

    if (this._isExpired) this.removeReproEntries();
    localStorage.setItem(key, val);

    const now = new Date();
    localStorage.setItem(STORAGE_EXPIRY_KEY, (now.getTime() + expires * 1000 * 60 * 60 * 24).toString());
  },
  remove(key: string): void {
    return localStorage.removeItem(key);
  },
  removeReproEntries() {
    const storedItemKeys = Object.keys(localStorage).filter((k) => k.match(/^rpr_/));
    storedItemKeys.forEach((key) => localStorage.removeItem(key));
  },
  get _isExpired(): boolean {
    const expires = localStorage.getItem(STORAGE_EXPIRY_KEY);
    if (!expires) return false;

    const now = new Date().getTime();
    return parseInt(expires, 10) <= now;
  },
  get isAvailable(): boolean {
    try {
      localStorage.setItem(AVAILABLE_CHECK_STORAGE_KEY, 'test');
      if (localStorage.getItem(AVAILABLE_CHECK_STORAGE_KEY) === 'test') {
        localStorage.removeItem(AVAILABLE_CHECK_STORAGE_KEY);
        return true;
      }
      return false;
    } catch (e) {
      // LocalStorageがOFFの場合はSecurityError、容量不足の場合はQuotaExceededError
      // https://developer.mozilla.org/ja/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
      if (
        e instanceof DOMException &&
        (e.name === 'SecurityError' || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
      ) {
        return false;
      }
      // エラーハンドリングする場合はErrorをthrowするが、いまは一旦console出力する
      console.error(e);
      return false;
    }
  },
};
